"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ObjectExpressionKeysTransformerCustomNode;
(function (ObjectExpressionKeysTransformerCustomNode) {
    ObjectExpressionKeysTransformerCustomNode["ObjectExpressionVariableDeclarationHostNode"] = "ObjectExpressionVariableDeclarationHostNode";
})(ObjectExpressionKeysTransformerCustomNode = exports.ObjectExpressionKeysTransformerCustomNode || (exports.ObjectExpressionKeysTransformerCustomNode = {}));
